import BaseLayer from "./BaseLayer";
import {plotFftRatioFourDTextUnit} from "../utils/map_utils";

class FFTRatioFourDText extends BaseLayer {

    id = "FFTRatioFourDText";
    label = "FFT Ratio Four D Text";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve, reject) => {
        let {normBlurValsFourd, rescanThresh, rescanThresh2, textColor, textSize} = this.props;
        if (this.props.label !== undefined) {
            this.label = this.props.label;
        }
        let ratioThresh = {}
        ratioThresh['l1'] = rescanThresh;
        ratioThresh['l2'] = rescanThresh2;
        let margin = 3 / 10;
        let sizeOfMarker = 0.3;
        for (let imageKey in normBlurValsFourd) {
            let xc = parseInt(imageKey.split('y')[0].split('x')[1]);
            let yc = parseInt(imageKey.split('y')[1].split('.' + this.props.slide.img_type)[0]);

            let v = {};
            let north_neigh = "x" + xc + "y" + (yc - 1);
            if (normBlurValsFourd[north_neigh] !== undefined && normBlurValsFourd[north_neigh]["SOUTH"] !== undefined) {
                let ratios = []
                if (normBlurValsFourd[imageKey]["NORTH"] && normBlurValsFourd[north_neigh]["SOUTH"]) {
                    for (let crop = 0; crop < normBlurValsFourd[imageKey]["NORTH"].length; crop++) {
                        let cur_north_val = normBlurValsFourd[imageKey]["NORTH"][crop];
                        let north_neigh_south_val = normBlurValsFourd[north_neigh]["SOUTH"][crop];
                        let rr = Math.round(1000 * Math.min(cur_north_val,
                            north_neigh_south_val) / Math.max(cur_north_val, north_neigh_south_val));
                        ratios.push(rr);
                    }
                }
                v['NORTH'] = ratios;
            }

            let west_neigh = "x" + (xc - 1) + "y" + yc;
            if (normBlurValsFourd[west_neigh] !== undefined && normBlurValsFourd[west_neigh]["EAST"] !== undefined) {
                let ratios = []
                if (normBlurValsFourd[imageKey]["WEST"] && normBlurValsFourd[west_neigh]["EAST"]) {
                    for (let crop = 0; crop < normBlurValsFourd[imageKey]["WEST"].length; crop++) {
                        let cur_west_val = normBlurValsFourd[imageKey]["WEST"][crop];
                        let west_neigh_east_val = normBlurValsFourd[west_neigh]["EAST"][crop];
                        let rr = Math.round(1000 * Math.min(cur_west_val, west_neigh_east_val) /
                            Math.max(cur_west_val, west_neigh_east_val));
                        ratios.push(rr);
                    }
                }
                v['WEST'] = ratios;
            }

            plotFftRatioFourDTextUnit(v, this.props.slide, xc, yc, margin, sizeOfMarker, this.layer.getSource(),
                ratioThresh, textColor, textSize);
        }
        resolve();
    });

}

export default FFTRatioFourDText;
